import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { socket } from '../fetchoptions';
import { setActive, Room } from '../features/usersSlice'
import { useDispatch } from 'react-redux';
import { MoreVertRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export default function Conversation () {
	let { active } = useSelector((state: RootState) => state.user)
	const dispatch = useDispatch()
	const defaultRooms: Array<Room> = []
	const [rooms, setRooms] = React.useState(defaultRooms)
	const search = (searchText: string) => {
		let rms = rooms;
		if (searchText)
		{
			setRooms(rms.filter((each, i) => each.name.toLowerCase().includes(searchText.toLowerCase())))
		} else
		{
			setRooms(defaultRooms);
		}

	}
	React.useEffect(() => {
		socket.emit('get-rooms');
		socket.on("get-rooms", (rooms) => {
			setRooms(rooms);
			// console.log(rooms);
		})
	}, [])

	return (
		<>
			<h3 className='font-bold  text-xl p-4 pb-0 sm:px-8 font-serif'>Rooms</h3>
			<div className='p-4 sm:px-8 w-full'>
				<input onChange={(e) => search(e.target.value)} className='px-4 py-2 text-xs dark:focus:text-slate-200 dark:bg-slate-600 dark:focus:bg-slate-500 outline-none focus:bg-slate-100 transition rounded bg-slate-50 w-full' placeholder='Search...' />
			</div>
			{rooms.map((room, i) => (
				<button key={room.id.toString()} className={`text-sm ${active?.id === room.id && 'bg-slate-100 dark:bg-slate-600'} hover:bg-slate-50 dark:hover:bg-slate-500 transition w-full items-center text-left flex pr-3 sm:pr-4`}>
					<span onClick={() => dispatch(setActive(room))} className='pl-5 sm:pl-8 py-3 w-full'>{room.name}</span>
					<IconButton className='text-blue-600' size='small'>
						<MoreVertRounded fontSize='small' className="text-gray-400" />
					</IconButton>
				</button>
			))}
		</>
	)
}